<script setup lang="ts">
    import { auth0Client } from '../main';
    import { ref } from 'vue';
    import { useRouter } from 'vue-router';
    import { appState } from '../game/logic';

    const router = useRouter();
    const isAuthenticated = ref(false);
    const name = ref('please log in');
    const sub = ref('');
    const token = ref('');

    const uxState = appState.uxState;

    console.log('Login.vue, setup...');

    auth0Client.isAuthenticated().then((result) => {
        isAuthenticated.value = result;
        uxState.isAuthenticated = result;
        console.log('isAuthenticated:', result);  

        if(result){
            //  Authenticated user:
            //  Just grab the 'sub' claim and we are ready to go.
            //
            //  Note: the 'sub' claim is connection dependent (different for every idp) 
            //  and the free Auth0 tier does not support linking accounts!
            //  Only option is to let the user every time login with same idp.
            auth0Client.getUser().then(user => {
                name.value = user?.name ?? 'unknown';
                sub.value = user?.sub ?? '';

                uxState.accountName = name.value;
                uxState.subject = sub.value;
                console.log('user:', user);

                auth0Client.getIdTokenClaims().then((claims) => {
                    console.log('claims:', claims);
                    const idToken = claims?.__raw;                    
                    token.value = idToken as string;
                    uxState.token = token.value;
                    uxState.accountName = name.value;
                    uxState.subject = sub.value;
                    appState.uxState = uxState;
                    
                });
                //  access token
                // auth0Client.getTokenSilently().then((responseToken) => {
                //     token.value = responseToken;
                //     console.log('token:', responseToken);

                //     uxState.token = token.value;
                //     uxState.accountName = name.value;
                //     uxState.subject = sub.value;
                //     appState.uxState = uxState;
                // });
            });
        }
        else {
            //  Not authenticated:
            //  We are either redirected from Auth0 or we are not logged in.
            //  If redirected from Auth0 login page, the code and state are present in query string
            const query = window.location.search;
            if (query.includes("code=") && query.includes("state=")) {      
                console.log('not logged in, handling redirect callback...');          
                auth0Client.handleRedirectCallback().then((result) => {
                    console.log('handleRedirectCallback success, appState:', result);
                    router.go(0);
                    auth0Client.isAuthenticated().then((result) => {
                        isAuthenticated.value = result;
                        uxState.isAuthenticated = result;
                        console.log('isAuthenticated:', result);                      
                        router.go(0);
                    });
                }).catch((error) => {
                    console.error('handleRedirectCallback error:', error);
                });
            } else {
                // not logged in yet
                console.log('not logged in, proceed with login button click!');
            }
        }
    });

    function login() {
        auth0Client.loginWithRedirect().catch((error) => {
            console.error('auth0 loginWithRedirect error:', error);
        });
    }

    function logout() {
        auth0Client.logout();
    }

    function startGame() {
        router.push({ path: '/game' });        
    }
</script>

<template>
    <div class="content">
        <h1>Player profile</h1>
        <div>{{ name }}</div>
        <div class="button-container">
            <div class="button-row">
                <button class="button" :disabled="isAuthenticated" @click="login()">Log in</button>
                <button class="button" :disabled="!isAuthenticated" @click="logout()">Log out</button>
            </div>
            <button class="button large" :disabled="!isAuthenticated" @click="startGame()">Play</button>
        </div>
    </div>
</template>

<style>
.button {
  background-color: #222;
  color: #fffecc;
  padding: 10px 20px;
  border: 1px solid;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1em;
  margin: 20px 5px 10px 0;
}

.button:disabled {
  background-color: #555;
  color: #999; 
  cursor: not-allowed; 
  opacity: 0.6; 
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 250px; /* the width of login/logout buttons, this makes the play button take the same width */
}

.button-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.button.large {
  flex: 1;              /* Take the full width of the container */
  margin-top: 20px; 
}
</style>